import React from 'react';
import PropTypes from 'prop-types';
import PickersControls from './PickersControls';
import PickersControlsDialog from './PickersControlsDialog';

const PickerSwitcher = ({ type = '' }) => (type === 'dialog' ? <PickersControlsDialog /> : <PickersControls />);

PickerSwitcher.propTypes = {
    type: PropTypes.string,
};

export default PickerSwitcher;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/components/PickerSwitcher.js
 **/